import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import "nprogress/nprogress.css";
import App from "./App.js";
import * as serviceWorker from "./serviceWorker";
import ConfigureStore from "./Redux/ConfigureStore";
import axios from "axios";
import { AxiosInterceptors } from "./Helper/axiosInterceptor.js";

const store = ConfigureStore();
AxiosInterceptors.setup(store);
// axios.defaults.withCredentials = true;
if (localStorage.getItem("LoginData")) {
  store.dispatch({
    type: "VERIFY_OTP_SUCCEEDED",
    data: JSON.parse(localStorage.getItem("LoginData")),
  });

  store.dispatch({
    type: "LOGIN",
  });
} else {
  store.dispatch({
    type: "LOGOUT",
  });
}

ReactDOM.render(
  <Provider store={store}>
    <App store={store} />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
